import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { renderTableTitle } from "@/utils/render.jsx";
import TextEllipsis from "@/components/Common/text-ellipsis.vue";
import { formatDate, auditCvsDataList, flattenUnitTree } from "@/utils/tool.js";
import { unitTree } from "@/service/unit.js";
import { listAuditModuleEvents, exportAuditLog, exportAuditLogFile, searchMembersAsPlainList } from "@/service/log.js";
export default {
  components: {
    TextEllipsis
  },
  data() {
    const h = this.$createElement;
    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    return {
      datePickerOptions: {},
      selectMinDate: null,
      selectMaxDate: null,
      loading: false,
      searchParams: {
        dateRange: [],
        operatorUserIds: [],
        module: "",
        events: [],
        unitId: (userInfo === null || userInfo === void 0 ? void 0 : userInfo.unitId) || ""
      },
      unitList: [],
      tableData: [],
      columns: [{
        title: $t("i5z22", "时间"),
        renderHeader: (h, {
          column
        }) => {
          // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
          return renderTableTitle(column.title, column, h);
        },
        key: "createTime",
        width: 180
      }, {
        title: $t("f5g8b3", "操作人"),
        renderHeader: (h, {
          column
        }) => {
          // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
          return renderTableTitle(column.title, column, h);
        },
        key: "userName",
        align: "left",
        width: 120,
        tooltip: true
      }, {
        title: $t("ayk45w4", "功能模块"),
        renderHeader: (h, {
          column
        }) => {
          // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
          return renderTableTitle(column.title, column, h);
        },
        key: "eventModule",
        align: "left",
        width: 150,
        tooltip: true,
        render: (h, {
          row
        }) => {
          let {
            eventModule
          } = row;
          return h("div", {
            "class": "flex gap-1"
          }, [h("Icon", {
            "attrs": {
              "type": "ios-alert-outline",
              "color": "#5EA1FF"
            },
            "class": "leading-[21px]"
          }), h("Tooltip", {
            "attrs": {
              "transfer": true
            }
          }, [h("span", {
            "class": "text-ellipsis"
          }, [eventModule]), h("template", {
            "slot": "content"
          }, [h("span", [eventModule])])])]);
        }
      }, {
        title: $t("a8stq34", "事件类型"),
        renderHeader: (h, {
          column
        }) => {
          // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
          return renderTableTitle(column.title, column, h);
        },
        key: "eventName",
        align: "left",
        width: 120,
        render: (h, {
          row
        }) => {
          let {
            eventName
          } = row;
          return h("div", {
            "class": "flex gap-1"
          }, [h("i", {
            "class": "icon-user_renyuan_people iconfont leading-[21px] text-[#BC71FD]"
          }), h("Tooltip", {
            "attrs": {
              "transfer": true
            }
          }, [h("span", {
            "class": "text-ellipsis"
          }, [eventName]), h("template", {
            "slot": "content"
          }, [h("span", [eventName])])])]);
        },
        tooltip: true
      }, {
        title: $t("d1xq544", "操作结果"),
        renderHeader: (h, {
          column
        }) => {
          // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
          return renderTableTitle(column.title, column, h);
        },
        key: "eventAction",
        align: "left",
        width: 150,
        render(h, {
          row
        }) {
          let {
            eventAction
          } = row;
          return h("div", {
            "class": "flex gap-1"
          }, [h("Tooltip", {
            "attrs": {
              "transfer": true
            }
          }, [h("span", {
            "class": "text-ellipsis"
          }, [eventAction]), h("template", {
            "slot": "content"
          }, [h("span", [eventAction])])])]);
        }
      }, {
        title: $t("i6ae1q4", "详细数据"),
        renderHeader: (h, {
          column
        }) => {
          // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
          return renderTableTitle(column.title, column, h);
        },
        slot: "detailData",
        render(h, {
          row
        }) {
          const detail = row.eventResult;
          // 空详情不挂载 Tooltip，避免鼠标经过时出现无内容的浮层。
          if (detail === null || detail === undefined || !String(detail).trim()) {
            return h("span", {
              "class": "audit-detail-empty"
            });
          }
          return h("Tooltip", {
            "attrs": {
              "maxWidth": 500,
              "transfer": true
            },
            "class": "text-left scrollable w-full"
          }, [h("div", {
            "class": "whitespace-pre-wrap break-words"
          }, [h("div", {
            "class": "line-clamp-3"
          }, [detail])]), h("template", {
            "slot": "content"
          }, [h("pre", {
            "class": "max-h-[300px] overflow-auto scrollable"
          }, [detail])])]);
        }
      }],
      moduleList: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      tableHeight: 0,
      detailVisible: false,
      selectedDetailData: null,
      zoomLevel: 100,
      auditMembers: []
    };
  },
  created() {
    // 初始化时设置默认日期范围为过去30天
    const endDate = new Date();
    // 正确计算30天前的时间（毫秒单位）
    const start = new Date(endDate.getTime() - 60 * 60 * 1000 * 24 * 30);
    this.searchParams.dateRange = [start, endDate];
    // 获取审计数据
    this.fetchAuditData();
  },
  computed: {
    eventTypeList() {
      var _this$moduleList$find;
      return ((_this$moduleList$find = this.moduleList.find(item => item.code === this.searchParams.module)) === null || _this$moduleList$find === void 0 ? void 0 : _this$moduleList$find.events) || [];
    },
    showOrgSelect() {
      return this.unitList.length > 1;
    }
  },
  methods: {
    // 表格高度取自弹性区域的实际剩余空间，为分页栏预留高度以兼容长语种筛选区。
    updateTableHeight() {
      const section = this.$refs.tableSection;
      const pagination = this.$refs.pagination;
      if (!section) return;
      this.tableHeight = Math.max(section.clientHeight - (pagination ? pagination.offsetHeight : 0), 0);
    },
    observeTableLayout() {
      this.updateTableHeight();
      if (typeof ResizeObserver !== "undefined") {
        this.tableResizeObserver = new ResizeObserver(this.updateTableHeight);
        this.tableResizeObserver.observe(this.$refs.tableSection);
        this.tableResizeObserver.observe(this.$refs.pagination);
      } else {
        window.addEventListener("resize", this.updateTableHeight);
      }
    },
    async fetchAuditMembers() {
      let {
        data: {
          retVal
        }
      } = await searchMembersAsPlainList();
      this.auditMembers = retVal;
    },
    // 获取审计数据
    async fetchAuditData(download = false, exportFileType = "csv") {
      this.loading = true;
      let {
        dateRange,
        events,
        module,
        operatorUserIds,
        unitId
      } = this.searchParams;
      let [startTime, endTime] = dateRange;
      startTime = formatDate(startTime);
      endTime = formatDate(endTime, "23:59:59");
      const moduleEvents = [];
      if (module) {
        if (events.length) {
          moduleEvents.push(...events);
        } else {
          const result = this.eventTypeList.map(item => item.code);
          moduleEvents.push(...result);
        }
      }
      let params = {
        operatorUserIds,
        unitId,
        events: moduleEvents,
        exportFileType,
        startTime,
        endTime,
        firstResult: (this.currentPage - 1) * this.pageSize,
        pageSize: this.pageSize,
        download
      };
      let {
        data,
        headers
      } = await exportAuditLog(params);
      let result = typeof data === "string";
      let total = headers["x-gc-total-rows"];
      this.total = total;
      this.tableData = result ? auditCvsDataList(data) : [];
      this.loading = false;
    },
    async getQueryOption() {
      let {
        data: {
          retVal
        }
      } = await listAuditModuleEvents();
      this.moduleList = (retVal || []).map(item => ({
        ...item,
        name: item.name ? item.name.replace(/^\[|\]$/g, "") : ""
      }));
    },
    findUnitName(id) {
      var _this$unitList$find;
      return ((_this$unitList$find = this.unitList.find(item => item.unitId === id)) === null || _this$unitList$find === void 0 ? void 0 : _this$unitList$find.name) || null;
    },
    async getUnitTree() {
      let {
        data: {
          result,
          retVal
        }
      } = await unitTree();
      if (result === 0) {
        this.unitList = flattenUnitTree([retVal]);
      }
    },
    // 搜索
    handleQueryChange() {
      this.currentPage = 1;
      this.fetchAuditData();
    },
    handleDateRangeChange(dateRange) {
      //如果时间在1个月内，则查询数据,否则提示报错
      if (dateRange && dateRange.length === 2) {
        const startTime = new Date(dateRange[0]);
        const endTime = new Date(dateRange[1]);
        // 计算时间跨度（毫秒）
        const timeDiff = endTime - startTime;
        // 转换为天数
        const daysDiff = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));
        if (daysDiff >= 31) {
          // 时间跨度在1个月内，执行查询
          // 时间跨度超过1个月，提示错误
          // lg: 查询时间跨度不能超过31天
          this.$Message.error($t("l9elcwd", "查询时间跨度不能超过31天"));
          // 超过30天，默认查询最近31天
          const endDate = new Date();
          const start = new Date(endDate.getTime() - 60 * 60 * 1000 * 24 * 30);
          this.searchParams.dateRange = [start, endDate];
        }
        this.handleQueryChange();
      }
    },
    handleModuleChange() {
      // 选中所有
      this.searchParams.events = this.eventTypeList.map(item => item.code);
      this.handleQueryChange();
    },
    // 查看详细数据
    showDetailData(row) {
      this.selectedDetailData = row.detailData;
      this.detailVisible = true;
    },
    // 分页变更
    handlePageChange(page) {
      this.currentPage = page;
      this.fetchAuditData();
    },
    // 每页条数变更
    handlePageSizeChange(size) {
      this.pageSize = size;
      this.currentPage = 1;
      this.fetchAuditData();
    },
    async handleExport() {
      try {
        let {
          dateRange,
          events,
          unitId,
          operatorUserIds
        } = this.searchParams;
        let [startTime, endTime] = dateRange;
        startTime = formatDate(startTime);
        endTime = formatDate(endTime, "23:59:59");
        const moduleEvents = [];
        if (module) {
          if (events.length) {
            moduleEvents.push(...events);
          } else {
            const result = this.eventTypeList.map(item => item.code);
            moduleEvents.push(...result);
          }
        }
        let params = {
          operatorUserIds,
          events: moduleEvents,
          exportFileType: "xlsx",
          startTime,
          endTime,
          unitId,
          firstResult: (this.currentPage - 1) * this.pageSize,
          pageSize: Number(this.total),
          download: true
        };
        let {
          data
        } = await exportAuditLogFile(params);
        let {
          addressBookName
        } = this.$store.state.user.userInfo;
        let name = this.findUnitName(unitId);
        // 格式化当前时间为YYYY-MM-DD HHmmss格式
        let now = new Date();
        let year = now.getFullYear();
        let month = String(now.getMonth() + 1).padStart(2, "0");
        let day = String(now.getDate()).padStart(2, "0");
        let currentTime = `${year}-${month}-${day}`;
        let fileName = `${$t('e2wp93', '审计-')}${addressBookName}-${name}-${currentTime}.xlsx`;
        // 创建Blob对象
        const blob = new Blob([data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });

        // 创建下载链接并触发下载
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);
        link.href = url;
        link.download = fileName;
        link.style.display = "none";
        document.body.appendChild(link);
        link.click();
        // 清理
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
        this.$Message.success($t("by5dal4", "导出成功"));
      } catch (error) {
        console.error("Export error:", error);
        this.$Message.error(error.message || $t("by46j64", "导出失败"));
      }
    }
  },
  mounted() {
    this.getUnitTree();
    this.getQueryOption();
    this.fetchAuditMembers();
    this.$nextTick(this.observeTableLayout);
  },
  beforeDestroy() {
    if (this.tableResizeObserver) {
      this.tableResizeObserver.disconnect();
    }
    window.removeEventListener("resize", this.updateTableHeight);
  }
};